import { render, staticRenderFns } from "./DialogWithOTPVerification.vue?vue&type=template&id=1a3598b1&scoped=true&"
import script from "./DialogWithOTPVerification.vue?vue&type=script&lang=js&"
export * from "./DialogWithOTPVerification.vue?vue&type=script&lang=js&"
import style0 from "./DialogWithOTPVerification.vue?vue&type=style&index=0&id=1a3598b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3598b1",
  null
  
)

export default component.exports